import {SectionHeader} from '@/components/main/common';
import {SoopUiSwiper} from '@/components/ui';
import MyCatch from '@/components/my/common/item/MyCatch';
import {decodeFullHtmlEntities} from '@/utils';
import {VOD_TYPES} from '@/constants';
import {CATCH_CONTEXT_MENU} from '@/constants/main';
import {useEffect, useState} from 'react';
import {useHiddenStreamer} from '@/components/main/common/hooks/useHiddenStreamer';

const swiperConfig = {
  loop: false,
  spaceBetween: 20,
};

const StoryDefaultTemplate = ({itemList, log = {}}) => {
  const [catchStoryList, setCatchStoryList] = useState([]);
  const [catchStoryTitle, setCatchStoryTitle] = useState('');
  const [catchStoryIdList, setCatchStoryIdList] = useState([]);
  const [userNick, setUserNick] = useState('');
  const {
    hiddenStreamerList,
    handleOnClickHiddenStreamer,
    handleOnClickUndoHiddenStreamer,
  } = useHiddenStreamer('CATCHSTORY', 'myplus');

  const handleOnClickMenu = (e, type, data) => {
    if (type === 'hidden') {
      handleOnClickHiddenStreamer(data);
    }
  };

  const handleUndoBroadcast = (data) => {
    if (hiddenStreamerList.includes(data.broadcastId)) {
      handleOnClickUndoHiddenStreamer(data);
    }
  };

  useEffect(() => {
    setCatchStoryIdList([...itemList.map((item) => item.storyIdx)]);
  }, []);

  return (
    <>
      <div className='catch_story_area'>
        <SoopUiSwiper
          swiperClass='catch_list catch_story_list'
          swiperTag='ul'
          maxSlidesPerView={10}
          otherMaxSlidesResolution={[
            {max: 1623, slidePerView: 10},
            {max: 1202, slidePerView: 8},
            {max: 1000, slidePerView: 6},
            {max: 751, slidePerView: 5},
            {max: 496, slidePerView: 4},
            {max: 0, slidePerView: 3},
          ]}
          options={swiperConfig}>
          {itemList.map((item, idx) => (
            <li key={idx} className='play_on'>
              <MyCatch
                {...{
                  ...item,
                  isAdult: Number(item.grade) === 19,
                  catchContextMenuList: CATCH_CONTEXT_MENU,
                }}
                title={decodeFullHtmlEntities(item.titleName)}
                catchId={item.catchId}
                isHorizontal={item.isHorizontal}
                isAdult={item.isAdult}
                thumbnailSrc={item.thumbnailSrc}
                userNickname={item.originalUserNick}
                userId={item.originalUserId}
                viewCount={item.viewCnt}
                broadcastDate={item.broadcastDate}
                listDataType={item.listDataType}
                fileType={item.fileType}
                isStory={item.isStory}
                catchIdList={catchStoryIdList}
                hiddenStreamerList={hiddenStreamerList}
                handleUndoBroadcast={handleUndoBroadcast}
                handleMenuClicked={handleOnClickMenu}
                isLogSendData={{path3: 'story', ...log}} // 스토리 섹션에서 노출되는 캐치도 유입경로를 story로 보내줘야 함
              />
            </li>
          ))}
        </SoopUiSwiper>
      </div>
    </>
  );
};

export default StoryDefaultTemplate;
